import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'site-forms-preview',
  templateUrl: './site-forms-preview.component.html',
})
export class SiteFormsPreviewComponent implements OnInit {
  @Input() formFields = [];

  constructor() { }

  ngOnInit() {
  }

}
